<button type="button" class="btn btn-sm btn-info" (click)="showPopup()"><span class="glyphicon glyphicon-th-list"></span> Wiedervorlagen</button>

<dx-popup class="popup"
          title="Wiedervorlagen"
          [height]="'70%'"
          [width]="'70%'"
          [showTitle]="true"
          [(visible)]="popupVisible"
          style="display: inline-block;">
  <div *dxTemplate="let data of 'content'">
    <dx-scroll-view #scrollView
                    id="scrollview"
                    [scrollByContent]="true"
                    [scrollByThumb]="true"
                    [showScrollbar]="'onHover'"
                    reachBottomText="Updating...">
      <div style="padding-right: 15px;">
        <cz-wiedervorlagen [ownerId]="ownerId" [entityArt]="entityArt"></cz-wiedervorlagen>
      </div>
    </dx-scroll-view>
  </div>

  <dxi-popup-toolbar-item widget="dxButton"
                    location="after"
                    toolbar="bottom"
                    [options]="{
            text: 'Schließen',
            onClick: hidePopup
        }">
  </dxi-popup-toolbar-item>


</dx-popup>
